import { render, staticRenderFns } from "./down-cost.vue?vue&type=template&id=4088e229&scoped=true&"
import script from "./down-cost.vue?vue&type=script&lang=js&"
export * from "./down-cost.vue?vue&type=script&lang=js&"
import style0 from "./down-cost.vue?vue&type=style&index=0&id=4088e229&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4088e229",
  null
  
)

export default component.exports